<script>
import { useI18n } from 'vue-i18n';
export default {
  setup() {
    const { t } = useI18n();
    return { t };
  },
  props: {
    bg: {
      type: String,
      default: "airbnbRed",
    },
    modelValue: {
      type: Number,
      default: 0,
    },
    firstIcon: {
      type: String,
      default: "save",
    },
    texts: {
      type: Array,
      default() {
        return [
          "components.submit_button.1",
          "components.submit_button.2",
          "components.submit_button.3",
        ];
      },
    },
  },
  data() {
    return {
      timeout: null,
    };
  },
  computed: {
    buttonBgColor() {
      if (this.modelValue === 2) {
        return ["bg-green-500"];
      }
      if (this.modelValue === 1) {
        return ["bg-gray-700"];
      }
      return [`bg-${this.bg}`];
    },
    icon() {
      if (this.modelValue === 2) {
        return "check";
      }
      if (this.modelValue === 1) {
        return "spinner";
      }
      return this.firstIcon;
    },
  },
  watch: {
    modelValue(val) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      if (val === 2) {
        this.timeout = setTimeout(() => {
          this.$emit("update:modelValue", 0);
        }, 1000);
      }
    },
  },
  methods: {
    clickHandler(e) {
      this.$emit("click", e);
    },
  },
};
</script>

<template>
  <button :class="buttonBgColor" class="p-3 font-semibold rounded text-white" :disabled="modelValue === 1" type="submit"
    @click="clickHandler">
    <font-awesome-icon :icon="icon" :spin="modelValue === 1" />
    <span class="pl-1">{{ $t(texts[modelValue]) }}</span>
  </button>
</template>
